/**************************************************
 * Nombre:       Home_Suscripcion
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid, InputAdornment, TextField, Typography} from "@mui/material";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import {useCargador} from "../../../Modulo_Cargador/Hooks/useCargador";
import logo from '../../../Recursos/logo_redondo.svg'
import {useDialogo} from "../../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Suscripcion from "../../Dialogos/Dialogo_Suscripcion";
import Dialogo_Politicas from "../../Dialogos/Dialogo_Politicas";
import {useContext, useEffect, useState} from "react";
import {contexApp} from "../../../App";
import {MailOutline} from '@mui/icons-material'

const Home_Suscripcion = () => {
    const {sCell, masSM, sTab} = useResponsive()
    const cData = useContext(contexApp)
    const {Avisos, Cargador, iniciarCarga, nuevoAviso, terminar} = useCargador({logoRedondo: logo})
    const {Dialogo, abrir} = useDialogo({Componente: Dialogo_Suscripcion})
    const {Dialogo: DialogoPol, abrir: abrirPol} = useDialogo({Componente: Dialogo_Politicas})
    const [politicas, setPoliticas] = useState([])
    const [correo, setCorreo] = useState('')


    useEffect(() => {

        if (cData.configuraciones) {
            setPoliticas(cData.configuraciones.politica_protenccion)
        }


    }, [cData.configuraciones]);
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}

        >


            <Grid
                container
                justifyContent={'center'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: sCell ? 4 : 6,}}
            >

                <Cargador/>
                <Avisos/>
                <Dialogo/>
                <DialogoPol/>

                <Grid container size={{xs: 12, sm: 12, md: 7}} sx={{py: 0, pr: sCell ? 0 : 6}}>
                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'center'}
                        size={{xs: 12, sm: 12, md: 12}}>


                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{mt: !masSM ? 6 : 0, justifyContent: 'center'}}>
                            <Typography
                                sx={{
                                    fontFamily: 'Dm Serif Display',
                                    fontSize: sCell ? 32 : 40,
                                    fontWeight: 400,
                                    lineHeight: 1,
                                    textAlign: sCell ? 'center' : 'center'
                                }}>ÚNETE A NUESTRA COMUNIDAD</Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: -2, justifyContent: 'center'}}>
                            <Typography sx={{
                                fontSize: 16,
                                fontWeight: 300,
                                textAlign: sCell ? 'center' : 'center'
                            }}>
                                <br/>
                                Suscríbete y recibe 10% OFF en tu primera compra
                            </Typography>
                        </Grid>


                        <Grid container size={{xs: 12, sm: 12, md: 10}} sx={{justifyContent: 'flex-start', mt: 4}}>
                            <TextField
                                value={correo}
                                onChange={e => setCorreo(e.target.value)}
                                label={'Correo Electronico'}
                                slotProps={{
                                    input: {
                                        startAdornment: (

                                            <InputAdornment position="start">
                                                <MailOutline color={'primary'}/>
                                            </InputAdornment>
                                        ),
                                        disableUnderline: true,
                                        sx: {borderRadius: 0}
                                    },
                                    inputLabel: {
                                        sx: {marginLeft: -1}
                                    }
                                }}
                            />
                        </Grid>


                        <Grid container size={{xs: 12, sm: 12, md: 10}} sx={{mt: 4, justifyContent: 'center'}}>
                            <Typography sx={{
                                fontSize: 14,
                                fontWeight: 300,
                                textAlign: sCell ? 'center' : 'center',
                                color: '#00000090'
                            }}>

                                Al registrarte, aceptas nuestra Política de Privacidad y autorizas el uso de tus datos
                                para recibir novedades, promociones y beneficios exclusivos.
                            </Typography>
                        </Grid>

                        <Grid container size={12}
                              sx={{
                                  mt: sTab ? 8 : 4,

                                  justifyContent: sCell ? 'center' : 'center',
                                  mb: !masSM ? 8 : 0
                              }}>
                            <Button
                                variant={'outlined'}
                                onClick={() => abrir({correo: correo})}
                                sx={{
                                    border: 1,
                                    backdropFilter: 'blur(2px)',
                                    boxShadow: 0,
                                    px: 6,
                                    py: 1
                                }}>SUSCRÍBETE</Button>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 4}} sx={{justifyContent: 'flex-start'}}>

                        </Grid>


                    </Grid>
                </Grid>


            </Grid>


        </Grid>
    )

}
export default Home_Suscripcion